import Http from '../libs/http';

export default {

  // 识别地址
  recognizeAddress(originStr) {
    return Http.post('/address_parse', { address: originStr });
  },
}
;



// WEBPACK FOOTER //
// ./src/services/address-service.js